var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"menu",class:{ 'menu--open': _vm.isOpen },attrs:{"role":"navigation"}},[_c('ul',{staticClass:"menu__container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }